import React from 'react';
import api from "./api";

const getAmountFormatted = (type,value)=>{
    switch (type){
        case "ppm":
            return `£ ${(value/100).toFixed(2)}/min`;
        case "per_video":
            return `£ ${(value/100).toFixed(2)}/video`;
        case "gallery":
            return `£ ${(value/100).toFixed(2)}/gallery`;
        case "subscription":
            return `£ ${(value/100).toFixed(2)}/month`;
    }
}
const setPricing = ($ppm,$per_video,$gallery,$subscription,selection = '')=>{
    return [{
        name: "select-payment-option",
        value: "ppm",
        label: "Pay per minute",
        isSelected: selection === "ppm",
        amount: $ppm,
        amount_formatted: getAmountFormatted("ppm",$ppm),
        description: "You can watch this video by paying per minute. You will be charged based on your watch minutes."
    },{
        name: "select-payment-option",
        value: "per_video",
        label: "Entire video",
        isSelected: selection === "per_video",
        amount: $per_video,
        amount_formatted: getAmountFormatted("per_video",$per_video),
        description: "You can watch Entire video with one time payment anytime. Also, automatically stored in saved list."
    },{
        name: "select-payment-option",
        value: "gallery",
        label: "Buy this gallery",
        isSelected: selection === "gallery",
        amount: $gallery,
        amount_formatted: getAmountFormatted("gallery",$gallery),
        description: "Gallery subscription offers you to watch all content in gallery with free of cost.  <a href='https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/EULA/terms.html' target='_blank'>T & C's</a>"
    },{
        name: "select-payment-option",
        value: "subscription",
        label: "Subscription Broadcaster",
        isSelected: selection === "subscription",
        amount: $subscription,
        amount_formatted: getAmountFormatted("subscription", $subscription),
        description: "Broadcaster subscription offers you to watch all his offline videos with free of cost. <a href='https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/EULA/terms.html' target='_blank'>T & C's</a>"
    }]
}

const subscribeToBroadcaster = (props,broadcasterID) => {
    if (props.moneyblox.hasOwnProperty("user_details") && props.moneyblox.user_details !== null) {
        const requestData = {
            id: broadcasterID,
            width: 500,
            height: null,
            moneyblox: {
                token: props.moneyblox.user_details.token,
                api_token: props.moneyblox.user_details.api_token,
            },
            device: {
                platform: props.device.platform,
                name: props.device.name,
                version: props.device.version,
                ip: props.device.ip,
                id: props.device.id,
                app_version: props.device.app_version,
                device_token: props.device.device_token,
            },
        };

        api.subscribeToBroadcasterAPI(props, requestData);
    }

}

const purchaseContent = (props, content, pricing) => {

    let requestData = {};

    if (props.moneyblox.hasOwnProperty("user_details") && props.moneyblox.user_details !== null) {

        //video or gallery
        let type = "video";
        let uuid = content.id;

        if (pricing.value === "subscription") {
            //subscription

            if (content.hasOwnProperty("videos")) {
                type = "gallery";
            }
            requestData = {
                id: content.broadcaster.id,
                width: 500,
                height: null,
                uuid: uuid,
                type: type,
                moneyblox: {
                    token: props.moneyblox.user_details.token,
                    api_token: props.moneyblox.user_details.api_token,
                },
                device: {
                    platform: props.device.platform,
                    name: props.device.name,
                    version: props.device.version,
                    ip: props.device.ip,
                    id: props.device.id,
                    app_version: props.device.app_version,
                    device_token: props.device.device_token,
                },
            };

            api.subscribeToBroadcasterAPI(props, requestData);

        } else {

            if (content.hasOwnProperty("videos")) {
                //this is gallery, lets see user is purchasing first video or gallery
                type = (pricing.value === "ppm" || pricing.value === "per_video") ? "video" : "gallery"
                if (type === "video") {
                    uuid = content.videos[0].id;
                }
            }

            requestData = {
                width: 500,
                height: null,
                uuid: uuid,
                type: type,
                pricing_type: type === "gallery" ? "per_video" : pricing.value,
                amount: pricing.amount,
                moneyblox: {
                    token: props.moneyblox.user_details.token,
                    api_token: props.moneyblox.user_details.api_token,
                },
                device: {
                    platform: props.device.platform,
                    name: props.device.name,
                    version: props.device.version,
                    ip: props.device.ip,
                    id: props.device.id,
                    app_version: props.device.app_version,
                    device_token: props.device.device_token,
                },
            };

            api.purchaseContentAPI(props, requestData);
        }
    }
}

const setPaymentChoice = (value,payload,callback) => {
    
    const subscription = payload.pricing.part_of_subscription === "yes" ? payload.pricing.subscription : 0
    let prices = setPricing(payload.pricing.ppm, payload.pricing.price, 0, subscription, value);

    if (payload.hasOwnProperty("videos")) {
        const video = payload.hasOwnProperty("videos") && Array.isArray(payload.videos) && payload.videos.length > 0 && payload.videos[0];
        prices = setPricing(video.pricing.ppm, video.pricing.price, payload.pricing.price, subscription, value);
    }

    callback(prices);
}

export default {
    set:setPricing,
    purchaseContent,
    setPaymentChoice,
    subscribeToBroadcaster
}